export const unionLocal = [
  {
    label: 'APWU - Northern Virginia Local 6803',
    value: 'AAPWUNorthernVirginiaLocal6803',
  },
  {
    label: 'APWU - Birmingham Area Local',
    value: 'AAPWUBirminghamAreaLocal',
  },
  {
    label: 'APWU - South Alabama Area Local 715',
    value: 'AAPWUSouthAlabamaAreaLocal715',
  },
  {
    label: 'APWU - Midnight Sun Area Local 2756',
    value: 'AAPWUMidnightSunAreaLocal2756',
  },
  {
    label: 'APWU - Phoenix Metro Area Local',
    value: 'AAPWUPhoenixMetroAreaLocal',
  },
  {
    label: 'APWU - Central Arkansas Area Local 189',
    value: 'AAPWUCentralArkansasAreaLocal189',
  },
  {
    label: 'APWU - Fayetteville Local 667',
    value: 'AAPWUFayettevilleLocal667',
  },
  {
    label: 'APWU - California State',
    value: 'AAPWUCaliforniaState',
  },
  {
    label: 'APWU - California Area Local 4635',
    value: 'AAPWUCaliforniaAreaLocal4635',
  },
  {
    label: 'APWU - High Desert Area Local 6074',
    value: 'AAPWUHighDesertAreaLocal6074',
  },
  {
    label: 'APWU - Oakland Local 78',
    value: 'AAPWUOaklandLocal78',
  },
  {
    label: 'APWU - San Diego Area Local',
    value: 'AAPWUSanDiegoAreaLocal',
  },
  {
    label: 'APWU - San Jose Area Local 73',
    value: 'AAPWUSanJoseAreaLocal73',
  },
  {
    label: 'APWU - Southwest Coastal Area Local 917',
    value: 'AAPWUSouthwestCoastalAreaLocal917',
  },
  {
    label: 'APWU - Colorado State',
    value: 'AAPWUColoradoState',
  },
  {
    label: 'APWU - Aurora Local',
    value: 'AAPWUAuroraLocal',
  },
  {
    label: 'APWU - Denver Area Local',
    value: 'AAPWUDenverAreaLocal',
  },
  {
    label: 'APWU - Western Colorado Area Local 600',
    value: 'AAPWUWesternColoradoAreaLocal600',
  },
  {
    label: 'APWU - Hartford Local 147',
    value: 'AAPWUHartfordLocal147',
  },
  {
    label: 'APWU - Wilmington/MTS Area Local 152',
    value: 'AAPWUWilmington/MTSAreaLocal152',
  },
  {
    label: 'APWU - Florida State',
    value: 'AAPWUFloridaState',
  },
  {
    label: 'APWU - Central Florida Area Local 1462',
    value: 'AAPWUCentralFloridaAreaLocal1462',
  },
  {
    label: 'APWU - Broward County Area Local 1201',
    value: 'AAPWUBrowardCountyAreaLocal1201',
  },
  {
    label: 'APWU - North Central Florida Area Local 3525',
    value: 'AAPWUNorthCentralFloridaAreaLocal3525',
  },
  {
    label: 'APWU - Palm Beach Area Local',
    value: 'AAPWUPalmBeachAreaLocal',
  },
  {
    label: 'APWU - Pensacola Area Local',
    value: 'AAPWUPensacolaAreaLocal',
  },
  {
    label: 'APWU - Southwest Florida Area Local',
    value: 'AAPWUSouthwestFloridaAreaLocal',
  },
  {
    label: 'APWU - Honolulu Local 162',
    value: 'AAPWUHonoluluLocal162',
  },
  {
    label: 'APWU - Illinois State',
    value: 'AAPWUIllinoisState',
  },
  {
    label: 'APWU - Northwest Illinois Area Local 7140',
    value: 'AAPWUNorthwestIllinoisAreaLocal7140',
  },
  {
    label: 'APWU - Indiana State',
    value: 'AAPWUIndianaState',
  },
  {
    label: 'APWU - Indianapolis Area Local',
    value: 'AAPWUIndianapolisAreaLocal',
  },
  {
    label: 'APWU - Iowa State',
    value: 'AAPWUIowaState',
  },
  {
    label: 'APWU - Kansas State',
    value: 'AAPWUKansasState',
  },
  {
    label: 'APWU - Portland Maine Area Local',
    value: 'AAPWUPortlandMaineAreaLocal',
  },
  {
    label: 'APWU - Massachusetts State',
    value: 'AAPWUMassachusettsState',
  },
  {
    label: 'APWU - Boston Metro Area Local 100',
    value: 'AAPWUBostonMetroAreaLocal100',
  },
  {
    label: 'APWU - Central Massachusetts Area Local 4553',
    value: 'AAPWUCentralMassachusettsAreaLocal4553',
  },
  {
    label: 'APWU - Springfield MA Area Local 497',
    value: 'AAPWUSpringfieldMAAreaLocal497',
  },
  {
    label: 'APWU - Michigan State',
    value: 'AAPWUMichiganState',
  },
  {
    label: 'APWU - Dave Lenard Local Area 480-481480-481 Area Local',
    value: 'AAPWUDaveLenardLocalArea480-481480-481AreaLocal',
  },
  {
    label: 'APWU - Detroit District Area Local',
    value: 'AAPWUDetroitDistrictAreaLocal',
  },
  {
    label: 'APWU - Western Michigan Area Local 281',
    value: 'AAPWUWesternMichiganAreaLocal281',
  },
  {
    label: 'APWU - Minneapolis Area Local 125',
    value: 'AAPWUMinneapolisAreaLocal125',
  },
  {
    label: 'APWU - St. Paul Area Local 65',
    value: 'AAPWUSt.PaulAreaLocal65',
  },
  {
    label: 'APWU - Mississippi State',
    value: 'AAPWUMississippiState',
  },
  {
    label: 'APWU - Missouri State',
    value: 'AAPWUMissouriState',
  },
  {
    label: 'APWU - Greater Kansas City Metro Area Local',
    value: 'AAPWUGreaterKansasCityMetroAreaLocal',
  },
  {
    label: 'APWU - Springfield Area Local',
    value: 'AAPWUSpringfieldAreaLocal',
  },
  {
    label: 'APWU - St. Louis Gateway District Area Local',
    value: 'AAPWUSt.LouisGatewayDistrictAreaLocal',
  },
  {
    label: 'APWU - Montana State',
    value: 'AAPWUMontanaState',
  },
  {
    label: 'APWU - Omaha Area Local 11',
    value: 'AAPWUOmahaAreaLocal11',
  },
  {
    label: 'APWU - Scottsbluff Area Local 845',
    value: 'AAPWUScottsbluffAreaLocal845',
  },
  {
    label: 'APWU - Greater Las Vegas Area Local 761',
    value: 'AAPWUGreaterLasVegasAreaLocal761',
  },
  {
    label: 'APWU - Reno Local 936',
    value: 'AAPWURenoLocal936',
  },
  {
    label: 'APWU - Manchester Area Local 230',
    value: 'AAPWUManchesterAreaLocal230',
  },
  {
    label: 'APWU - Central New Jersey Areal Local 149',
    value: 'AAPWUCentralNewJerseyArealLocal149',
  },
  {
    label: 'APWU - NJ International & BMC (NY Metro Local 10)',
    value: 'AAPWUNJInternational&BMC(NYMetroLocal10)',
  },
  {
    label: 'APWU - South Jersey Area Local',
    value: 'AAPWUSouthJerseyAreaLocal',
  },
  {
    label: 'APWU - North Jersey Area Local',
    value: 'AAPWUNorthJerseyAreaLocal',
  },
  {
    label: 'APWU - Albuquerque Local 380',
    value: 'AAPWUAlbuquerqueLocal380',
  },
  {
    label: 'APWU - New Mexico State',
    value: 'AAPWUNewMexicoState',
  },
  {
    label: 'APWU - Albany Area Local 390',
    value: 'AAPWUAlbanyAreaLocal390',
  },
  {
    label: 'APWU - Long Island Area Local',
    value: 'AAPWULongIslandAreaLocal',
  },
  {
    label: 'APWU - New York Metro Area Local',
    value: 'AAPWUNewYorkMetroAreaLocal',
  },
  {
    label: 'APWU - Queens Area Local',
    value: 'AAPWUQueensAreaLocal',
  },
  {
    label: 'APWU - Rochester SCF Area Local 215',
    value: 'AAPWURochesterSCFAreaLocal215',
  },
  {
    label: 'APWU - Western New York Area Local 183',
    value: 'AAPWUWesternNewYorkAreaLocal183',
  },
  {
    label: 'APWU - NC Council',
    value: 'AAPWUNCCouncil',
  },
  {
    label: 'APWU - Charlotte Area Local 375',
    value: 'AAPWUCharlotteAreaLocal375',
  },
  {
    label: 'APWU - Cleveland Ohio Area Local 72',
    value: 'AAPWUClevelandOhioAreaLocal72',
  },
  {
    label: 'APWU - Greater Cincinnati Area Local',
    value: 'AAPWUGreaterCincinnatiAreaLocal',
  },
  {
    label: 'APWU - Toledo Local 170',
    value: 'AAPWUToledoLocal170',
  },
  {
    label: 'APWU - Youngstown Area Local #443',
    value: 'AAPWUYoungstownAreaLocal#443',
  },
  {
    label: 'APWU - Tulsa Area Local 1348',
    value: 'AAPWUTulsaAreaLocal1348',
  },
  {
    label: 'APWU - Portland Oregon Area Local',
    value: 'AAPWUPortlandOregonAreaLocal',
  },
  {
    label: 'APWU - Southern Oregon Area Local 342',
    value: 'AAPWUSouthernOregonAreaLocal342',
  },
  {
    label: 'APWU - Pennsylvania State',
    value: 'AAPWUPennsylvaniaState',
  },
  {
    label: 'APWU - Greensburg Foothills Area Local 1948',
    value: 'AAPWUGreensburgFoothillsAreaLocal1948',
  },
  {
    label: 'APWU - Lehigh Valley Area Local',
    value: 'AAPWULehighValleyAreaLocal',
  },
  {
    label: 'APWU - Philadelphia Area Local 89',
    value: 'AAPWUPhiladelphiaAreaLocal89',
  },
  {
    label: 'APWU - Philadelphia BMC Local 7048',
    value: 'AAPWUPhiladelphiaBMCLocal7048',
  },
  {
    label: 'APWU - Pittsburgh Metro Local 81',
    value: 'AAPWUPittsburghMetroLocal81',
  },
  {
    label: 'APWU - Wilkes-Barre Area Local 175',
    value: 'AAPWUWilkes-BarreAreaLocal175',
  },
  {
    label: 'APWU - Rhode Island State',
    value: 'AAPWURhodeIslandState',
  },
  {
    label: 'APWU - Providence Area Local',
    value: 'AAPWUProvidenceAreaLocal',
  },
  {
    label: 'APWU - South Carolina State',
    value: 'AAPWUSouthCarolinaState',
  },
  {
    label: 'APWU - Upper Piedmont Area Local',
    value: 'AAPWUUpperPiedmontAreaLocal',
  },
  {
    label: 'APWU - Nashville Area Local',
    value: 'AAPWUNashvilleAreaLocal',
  },
  {
    label: 'APWU - Texas Postal Workers Union',
    value: 'AAPWUTexasPostalWorkersUnion',
  },
  {
    label: 'APWU - Fort Worth Area Local',
    value: 'AAPWUFortWorthAreaLocal',
  },
  {
    label: 'APWU - Dallas Area Local 732',
    value: 'AAPWUDallasAreaLocal732',
  },
  {
    label: 'APWU - Houston Area Local',
    value: 'AAPWUHoustonAreaLocal',
  },
  {
    label: 'APWU - Lubbock Area Local 952',
    value: 'AAPWULubbockAreaLocal952',
  },
  {
    label: 'APWU - San Antonio Alamo Area Local 195',
    value: 'AAPWUSanAntonioAlamoAreaLocal195',
  },
  {
    label: 'APWU - Provo Local 42',
    value: 'AAPWUProvoLocal42',
  },
  {
    label: 'APWU - Salt Lake City Area Local',
    value: 'AAPWUSaltLakeCityAreaLocal',
  },
  {
    label: 'APWU - Norfolk Local 262',
    value: 'AAPWUNorfolkLocal262',
  },
  {
    label: 'APWU - Washington State',
    value: 'AAPWUWashingtonState',
  },
  {
    label: 'APWU - West Virginia State',
    value: 'AAPWUWestVirginiaState',
  },
  {
    label: 'APWU - Charleston WV Local 133',
    value: 'AAPWUCharlestonWVLocal133',
  },
  {
    label: 'APWU - Milwaukee Area Local',
    value: 'AAPWUMilwaukeeAreaLocal',
  },
  {
    label: 'APWU - Northeastern Wisconsin Area Local 2247',
    value: 'AAPWUNortheasternWisconsinAreaLocal2247',
  },
  {
    label: 'APWU - Twin Cities Local 7019',
    value: 'AAPWUTwinCitiesLocal7019',
  },
  {
    label: 'APWU - Central New York Area Local 257',
    value: 'AAPWUCentralNewYorkAreaLocal257',
  },
  {
    label: 'NMPHU - Ohio Kentucky Indiana Local 304',
    value: 'NNMPHUOhioKentuckyIndianaLocal304',
  },
  {
    label: 'APWU - Tampa Area Local 259',
    value: 'AAPWUTampaAreaLocal259',
  },
  {
    label: 'NALC - St. Louis Branch 343',
    value: 'NNALCSt.LouisBranch343',
  },
  {
    label: 'AFGE - Indiana Local 44',
    value: 'AAFGEIndianaLocal44',
  },
]
